;(function () {
  angular
    .module('contrast.reports')
    .controller(
      'VulnerabilityTrendReportCtrl',
      function (
        $scope,
        ErrorService,
        reportFilterService,
        PromiseService,
        orgTraceApiConfig,
        VULNERABILITY_REPORT_RANGES,
        VULNERABILITY_REPORT_TYPE
      ) {
        'ngInject'

        var lastSearch

        angular.extend($scope, {
          model: {
            type: VULNERABILITY_REPORT_TYPE.NEW,
            range: 'week',
            applications: [],
            servers: [],
            rules: []
          },
          select: {
            ranges: VULNERABILITY_REPORT_RANGES
          },
          vulnTrendChartData: {
            loaded: false,
            closed: [],
            open: []
          }
        })

        angular.extend($scope, {
          onChange: onChange
        })

        function init() {
          var storedValues = reportFilterService.getAll()

          $scope.model.type = storedValues.type
          $scope.model.range = storedValues.range
          $scope.model.applications = storedValues.applications
          $scope.model.rules = storedValues.rules
          $scope.model.servers = storedValues.servers

          _getGraphData()
        }

        function onChange() {
          reportFilterService.setType($scope.model.type)
          reportFilterService.setRange($scope.model.range)

          _getGraphData()
        }

        function _getGraphData() {
          $scope.vulnTrendChartData.loaded = false
          if (lastSearch) {
            PromiseService.cancelPromise(lastSearch)
          }

          var form = reportFilterService.createRequest()

          if ($scope.model.type == VULNERABILITY_REPORT_TYPE.NEW) {
            lastSearch = orgTraceApiConfig.getNewTrendData(
              $scope.model.range,
              form
            )
          } else {
            lastSearch = orgTraceApiConfig.getTotalTrendData(
              $scope.model.range,
              form
            )
          }

          return lastSearch.then(
            function (response) {
              $scope.vulnTrendChartData.loaded = true
              $scope.vulnTrendChartData.closed = response.data.closed
              $scope.vulnTrendChartData.open = response.data.open
            },
            function (response) {
              ErrorService.processError(response)
            }
          )
        }

        init()
      }
    )
})()
